// Ant Design Vue
import * as Sentry from '@sentry/vue'
import Antd, { message } from 'ant-design-vue'
import { createPinia } from 'pinia'
import { configure } from 'vee-validate'
import { createApp } from 'vue'
import { useAuthStore } from '@/stores/auth'
import App from './App.vue'
import router from './router'
import 'ant-design-vue/dist/reset.css'
import './util.css'

const app = createApp(App)

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: __APP_COMMIT__,
    tracesSampleRate: 0.5,
    tracePropagationTargets: ['localhost', /^https:\/\/.*\.vercel\.app/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  })
}

// Configure VeeValidate
configure({
  validateOnInput: true,
  validateOnChange: true,
  validateOnModelUpdate: true,
})

const pinia = createPinia()
app.use(pinia)

app.config.errorHandler = (error, _instance, _info) => {
  console.error('Unhandled error:', error)
  message.error('An unexpected error occurred.')
}

// Restore auth state before router navigation to avoid race
const authStore = useAuthStore(pinia)
await authStore.restoreSession().catch((error) => {
  console.warn('Auth restore failed', error)
})

app.use(router)
app.use(Antd)

app.mount('#app')
